import React from "react";
import { useTranslation } from "react-i18next";

import {
  TextDetailSection,
  ContentWrapper,
  SectionTitle,
  MainHeading,
  BodyText
} from "./TextDetail.styled";

const TextDetail = () => {
  const { t } = useTranslation();
  const paragraphs = t("impactReport.textDetail.paragraphs", {
    returnObjects: true
  });

  return (
    <TextDetailSection>
      <ContentWrapper>
        <SectionTitle>{t("impactReport.textDetail.sectionTitle")}</SectionTitle>
        <MainHeading>{t("impactReport.textDetail.heading")}</MainHeading>
        {paragraphs.map((paragraph, index) => (
          <BodyText key={index}>{paragraph}</BodyText>
        ))}
      </ContentWrapper>
    </TextDetailSection>
  );
};

export default TextDetail;
